export enum SettingsTabs {
    general = 'general',
    pinCode = 'pinCode',
    pinTwoFa = 'pinTwoFa',
    pinSuccess = 'pinSuccess',
    threeDSGeneral = 'threeDSGeneral',
    threeDSSms = 'threeDSSms',
    threeDSEmail = 'threeDSEmail',
    threeDSBio = 'threeDSBio',
    threeDSApproval = 'threeDSApproval',
    threeDSAbout = 'threeDSAbout',
    threeDSSecurity = 'threeDSSecurity',
    threeDSQuestionFlow = 'threeDSQuestionFlow',
    threeDSTwoFa = 'threeDSTwoFa',
    block = 'block',
}
